import Ext from 'Ext'
import $ from 'jquery'
import messageResource from '../messageResource'
import GroupType from "../enums/GroupType";
import SimpleSelectorPanel from "./selectorControls/at_simple_selector_panel";
import SimpleListSelectorTree from "./selectorControls/at_simple_list_selector_tree";
import GenericSelectorTreePropertiesController from "./selectorControls/GenericSelectorTreePropertiesController";
import SelectorTreeCheckbox from "./selectorControls/at_selector_tree_checkbox";
import GroupSelectorSwitcher from "./selectorControls/at_group_selector_switcher";
import {atImgPath} from '../atBrowserUtils'
import ScrollUtils from '../util/ScrollUtils'
import FlatButton from "./at_flat_button";
import GradientButton from "./at_gradient_button";
/**
 * @author kostenko
 *
 * User groups selector panel.
 *
 * Depends on:
 * <code>/js/controls/selectorControls/at_simple_selector_panel.js</code>
 * <code>/js/message_resources.js</code> with prefixes "common" and "user_groups_selector"
 */

const UserGroupsSelectorTreePropertiesController = Ext.extend(GenericSelectorTreePropertiesController, {
    isActive: function() { return true; } // archived groups are not supported
});

const TimeZoneGroupSelectorTreeCheckbox = Ext.extend(SelectorTreeCheckbox, {

    itemDefaultCls: "defaultGroup",

    createNodeLabel: function(item)
    {
        var escapedName =  Ext.util.Format.htmlEncode(this.label);
        if (!item.isDefault)
            return escapedName;

        return "<span class='defaultGroupName'>" + escapedName + "</span><span class='defaultGroupNote'>&nbsp;" +
               messageResource.getMessage("users_selector.default_group")+ "</span>"
    },

    initComponent: function()
    {
        TimeZoneGroupSelectorTreeCheckbox.superclass.initComponent.call(this);

        if (this.item.isDefault) {
            this.addClass(this.itemDefaultCls);
        }
    }

});

const GroupsSelectorTree = Ext.extend(SimpleListSelectorTree, {

    groupType: GroupType.USER_GROUP,

    createNodes: function()
    {
        var nodes = [];
        var selectorTreeCheckboxCtor = this.groupType === GroupType.TIME_ZONE_GROUP ? TimeZoneGroupSelectorTreeCheckbox : SelectorTreeCheckbox;
        Ext.each(this.data, function(item) {
            var node = new selectorTreeCheckboxCtor({
                                                        item: item,
                                                        label: this.getNameWithStatus(item)
                                                    });
            nodes.push(node);
            node.on("change", this.onChange, this);
        }, this);

        return nodes;
    },

    setGroupType: function(groupType)
    {
        this.groupType = groupType;
    }

});

export const GroupsSelectorPanel = Ext.extend(SimpleSelectorPanel, {
    showShowInactiveCheckbox: false,

    allItemsOptionLabelKey: "user_groups_selector.options.all_items",
    selectedAllItemsOptionLabelKey: "user_groups_selector.smart.message.all_items.selected",
    allItemsBoldOptionLabelKey: 'user_groups_selector.options.all_items_bold',
    customOptionLabelKey: "user_groups_selector.options.custom",

    labelNoItemsSelectedKey: "user_groups_selector.smart.message.all_items.selected",

    closeButtonLabelKey: "user_groups_selector.close_button.label",

    labelUseNameForSingleItem: true,
    showInactiveLabelKey: "userlist.js.filter_by_groups.show_disabled_users",

    propertiesControllerCtor: UserGroupsSelectorTreePropertiesController,

    userGroupsData: null,
    timeZoneGroupsData: null,
    groupType: null,

    groupTypeSettingCookieName: "groupSelectorGroupTypeSetting",

    selectorTreeCtor: GroupsSelectorTree,

    createComponents: function()
    {
        GroupsSelectorPanel.superclass.createComponents.call(this);
        this.viewByPanel = new GroupSelectorSwitcher();
    },

    initComponent: function()
    {
        this.userGroupsEnabled = this.userGroupsData != null && this.userGroupsData.length !== 0;
        this.timeZoneGroupsEnabled = this.timeZoneGroupsData != null && this.timeZoneGroupsData.length !== 0;

        if (this.groupType !== GroupType.USER_GROUP && this.groupType !== GroupType.TIME_ZONE_GROUP)
        {
            var groupTypeSettingFromCookie = $.cookie(this.groupTypeSettingCookieName);
            if (groupTypeSettingFromCookie)
            {
                this.groupType = groupTypeSettingFromCookie === "timeZoneGroup" ? GroupType.TIME_ZONE_GROUP : GroupType.USER_GROUP;
            }
            else
            {
                this.groupType = GroupType.USER_GROUP;
            }
        }

        if (this.groupType === GroupType.TIME_ZONE_GROUP && !this.timeZoneGroupsEnabled)
            this.groupType = GroupType.USER_GROUP;

        if (this.groupType === GroupType.USER_GROUP && !this.userGroupsEnabled)
            this.groupType = GroupType.TIME_ZONE_GROUP;

        this.groupTypeInit = this.groupType;

        if (!this.data || this.data.length === 0)
            this.data = this.groupType === GroupType.USER_GROUP ? this.userGroupsData : this.timeZoneGroupsData;

        this.createInitialUserGroupsDataIfNeeded();
        this.createInitialTimeZoneGroupsDataIfNeeded();

        GroupsSelectorPanel.superclass.initComponent.call(this);
        this.addClass("group-selector-panel");

        var self = this;
        this.viewByPanel.init(this.userGroupsEnabled, this.timeZoneGroupsEnabled,
                              function() { self.selectorTree.onChange(); self.groupByUserGroup(); }, function() { self.selectorTree.onChange(); self.groupByTimeZoneGroup(); });
        if (this.groupType === GroupType.TIME_ZONE_GROUP){
            this.groupByTimeZoneGroup();
        }
        else {
            this.groupByUserGroup();
        }
    },

    setInitialValuesFromCurrent: function()
    {
        GroupsSelectorPanel.superclass.setInitialValuesFromCurrent.call(this);
        this.groupTypeInit = this.groupType;
        this.createInitialUserGroupsDataIfNeeded();
        this.createInitialTimeZoneGroupsDataIfNeeded();
    },

    createInitialUserGroupsDataIfNeeded: function()
    {
        if (this.userGroupsEnabled)
        {
            this.initialUserGroupsData = $.map(this.userGroupsData, function(obj)
            {
                return $.extend({}, obj);
            });
        }
    },

    createInitialTimeZoneGroupsDataIfNeeded: function()
    {
        if (this.timeZoneGroupsEnabled)
        {
            this.initialTimeZoneGroupsData = $.map(this.timeZoneGroupsData, function (obj) {
                return $.extend({}, obj);
            });
        }
    },

    getCustomOptionSection: function() {
        var buttons  = [];
        buttons.push(this.selectAllButton);
        buttons.push(this.makeVerticalSeparator(), this.clearButton);

        var customOptionButtonsSection =  new Ext.Panel({
            cls: "buttonsPanel",
            autEl: "div",
            items: buttons
        });

        var customOptionControls = [];
        // from left to right
        customOptionControls.push(this.viewByPanel);
        customOptionControls.push(customOptionButtonsSection);

        this.customControlsContainer = new Ext.Container({
            cls: "userSelectorCustomControlsContainer",
            autoEl: "div",
            items: customOptionControls
        });
        return [this.customOption, this.customControlsContainer];
    },

    groupByUserGroup: function()
    {
        this.data = this.userGroupsData;
        if (!this.data)
            return;
        
        this.groupType = GroupType.USER_GROUP;
        this.updateGroups(this.data);

        this.viewByPanel.updateUI(this.groupType);
        this.saveGroupBySettingsToCookie("userGroup");
    },

    groupByTimeZoneGroup: function()
    {
        this.data = this.timeZoneGroupsData;
        if (!this.data)
            return;
        
        this.groupType = GroupType.TIME_ZONE_GROUP;
        this.updateGroups(this.data);

        this.viewByPanel.updateUI(this.groupType);
        this.saveGroupBySettingsToCookie("timeZoneGroup");
    },

    createGenericOptions: function()
    {
        this.genericOptions = [
            new Ext.form.Radio({
                                   boxLabel: messageResource.getMessage( this.allItemsBoldOptionLabelKey, [ messageResource.getEscapedMessage( this.labelItemNounPluralKey ) ] ),
                                   name: this.realOptionsName,
                                   inputValue: this.allItemsOptionValue
                               })
        ];
    },

    createCustomOption: function ()
    {
        this.customOption = new Ext.form.Radio({
                                                   boxLabel: messageResource.getMessage( 'user_groups_selector.options.custom_bold', [ messageResource.getEscapedMessage( this.labelItemNounPluralKey ) ] ),
                                                   name: this.realOptionsName,
                                                   inputValue: this.customOptionValue
                                               });
    },

    getAllSelectedString: function(maxLength) {
        return messageResource.getEscapedMessage(this.selectedAllItemsOptionLabelKey);
    },

    createFooterButtons: function() {
        this.resetButton = new FlatButton({
                                                 icon: atImgPath("undo.gif"),
                                                 text: messageResource.getMessage(this.resetButtonLabelKey)
                                             });
        this.closeButton = new GradientButton({
                                                     text: messageResource.getMessage(this.closeButtonLabelKey),
                                                     minWidth: 60,
                                                     cls: "greyButton close-button"
                                                 });
        this.resetButton.addClass("resetButton");
    },

    updateGroupsData: function ( userGroupWrappersList, timeZoneGroupWrappersList, skipUpdateInitialValues )
    {
        this.userGroupsData = userGroupWrappersList;
        this.timeZoneGroupsData = timeZoneGroupWrappersList;

        // We may not want to update init values, for instance when resetting
        if ( !skipUpdateInitialValues ) {
            this.setInitialValuesFromCurrent();
        }

        if (this.groupType === GroupType.USER_GROUP)
            this.groupByUserGroup();
        else
            this.groupByTimeZoneGroup();

        if( this.getSelection().length === 0 )
            this.selectOption( this.allItemsOptionValue );
    },

    updateGroups: function ( groupWrappersList )
    {
        this.selectorTree.setGroupType(this.groupType);
        this.selectorTree.rebuildTree( groupWrappersList );
        this.selectorTree.setInitialSelectionFromCurrent();
        this.doLayout();
        this.fireChangeEvent();
        ScrollUtils.refreshCustomScroll(this.customScroller);
    },

    getGroupType: function()
    {
        return this.isCustomOptionSelected() && this.groupType ? this.groupType : null;
    },

    saveGroupBySettingsToCookie: function (value)
    {
        $.cookie(this.groupTypeSettingCookieName, value, { expires: 365 });
    },

    resetState: function(isEnableActiveActions) {
        this.beforeResetAction();
        GroupsSelectorPanel.superclass.resetState.call(this, isEnableActiveActions);
        this.afterResetAction();
    },

    beforeResetAction: function(){
        this.groupType = this.groupTypeInit;
        if (this.userGroupsEnabled)
        {
            this.userGroupsData = $.map(this.initialUserGroupsData, function(obj)
            {
                return $.extend({}, obj);
            });
        }
        if (this.timeZoneGroupsEnabled)
        {
            this.timeZoneGroupsData = $.map(this.initialTimeZoneGroupsData, function(obj)
            {
                return $.extend({}, obj);
            });
        }

        this.updateGroupsData(this.userGroupsData, this.timeZoneGroupsData, true);
    },



    afterResetAction: function()
    {
        GroupsSelectorPanel.superclass.afterResetAction.call(this);
        this.viewByPanel.updateUI(this.groupTypeInit);
    },

    onGenericOptionSelect: function(option, checked) {
        if(checked)
            this.addClass("hideCustomOptionField");
        GroupsSelectorPanel.superclass.onGenericOptionSelect.call(this, option, checked);
    },

    onCustomOptionSelect: function(option, checked) {
        if(checked)
        {
            this.removeClass("hideCustomOptionField");
            ScrollUtils.refreshCustomScroll(this.customScroller);
        }
        GroupsSelectorPanel.superclass.onCustomOptionSelect.call(this, option, checked);
    },

    render : function(ct, pos)
    {
        GroupsSelectorPanel.superclass.render.apply(this,arguments);
        this.customScroller = ScrollUtils.addVerticalScroll($(this.selectorTree.el.dom), {isFaded: false});
    },

    isStateChanged: function()
    {
        if (this.getCurrentOptionValue() !== this.optionValueInit)
            return true;

        if (this.groupTypeInit !== this.groupType)
            return true;

        var initialData = this.groupType === GroupType.USER_GROUP ? this.initialUserGroupsData : this.initialTimeZoneGroupsData;

        for (var i = 0; i < this.data.length; i++)
        {
            if (initialData[i] && initialData[i].selected !== this.data[i].selected )
                return true;
        }

        return false;
    }
});

export const SmartGroupsSelectorPanel = Ext.extend( GroupsSelectorPanel, {
    cls: "selector-panel userGroupsSelector",

    labelUseNameForSingleItem: false,

    allItemsOptionLabelKey: "user_groups_selector.smart.options.all_items",
    allItemsBoldOptionLabelKey: 'user_groups_selector.smart.options.all_items_bold',

    labelItemNounSingularKey: "user_groups_selector.smart.label.user_group.singular",
    labelItemNounPluralKey: "user_groups_selector.smart.label.user_group.plural",
    labelNoItemsSelectedKey: "user_groups_selector.smart.message.all_items.selected",

    userWithoutDepartmentLabel:  "user_groups_selector.without_department.label",


    selectAll: function()
    {
        this.selectOption( this.allItemsOptionValue );
    },

    getDescription: function(selectorHelper){
        var selection = this.getSelection();
        if (selection.length === 1 && this.getGroupType() === GroupType.USER_GROUP && selection[0].id <= 0){
            return messageResource.getEscapedMessage(this.userWithoutDepartmentLabel);
        }
        if(this.getGroupType() === GroupType.USER_GROUP){
            this.labelItemNounSingularKey = "user_groups_selector.smart.label.user_group.singular";
            this.labelItemNounPluralKey = "user_groups_selector.smart.label.user_group.plural";
        }
        if(this.getGroupType() === GroupType.TIME_ZONE_GROUP){
            this.labelItemNounSingularKey = "user_groups_selector.smart.label.time_zone_group.singular";
            this.labelItemNounPluralKey = "user_groups_selector.smart.label.time_zone_group.plural";
        }

        return GroupsSelectorPanel.superclass.getDescription.call(this,selectorHelper);
    }
} );



// WEBPACK FOOTER //
// ./web/js/controls/at_groups_selector_panel.js